import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { clearCompanionSession, getCompanionSession } from "../auth/session";
import DashboardLayout from "../components/Dashboard/DashboardLayout";
import {
  getDashboardLoginPath,
  isDashboardAreaPath,
  isDashboardLoginPath,
  toDesktopDashboardPath,
  toMobileDashboardPath,
} from "../utils/dashboardPaths";

/**
 * Canonical URL vs UA runs first, then session guard — both in one effect so pathname
 * is normalized before unauth redirect (e.g. mobile /dashboard → /m/dashboard/overview).
 */
export default function DashboardLayoutRoute(): React.JSX.Element {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const pathname = location.pathname;

    const mobileCanonical = toMobileDashboardPath(pathname);
    if (mobileCanonical) {
      navigate(mobileCanonical, { replace: true });
      return;
    }

    const desktopCanonical = toDesktopDashboardPath(pathname);
    if (desktopCanonical) {
      navigate(desktopCanonical, { replace: true });
      return;
    }

    if (!isDashboardAreaPath(pathname)) {
      return;
    }
    if (isDashboardLoginPath(pathname)) {
      return;
    }

    const session = getCompanionSession();
    if (session) {
      return;
    }

    clearCompanionSession();
    navigate(getDashboardLoginPath(), { replace: true });
  }, [location.pathname, navigate]);

  return <DashboardLayout pathname={location.pathname} />;
}
